import {KeyValue} from 'airship/modules/typesafe-request'
import {
  enumResolver,
  objectResolver,
  optionalResolver,
  resolveString,
} from 'airship/utils/resolvers'
import {Resolver} from 'airship/utils/resolvers/types'

export enum AuthErrorMessage {
  VALIDATION = 'validation',
}

export type AuthResponse = {
  redirectTo?: string
  error?: AuthErrorMessage
}

export const resolveAuthResponse: Resolver<AuthResponse> = objectResolver({
  redirectTo: optionalResolver(resolveString),
  error: optionalResolver(enumResolver(AuthErrorMessage)),
})

export type LoginArgs = {
  username: string
  password: string
  staySignedIn?: boolean
  recaptchaToken?: string
  queryStringParams?: KeyValue
}

export type FindUserArgs = {
  username: string
  recaptchaToken?: string
  queryStringParams?: KeyValue
}

export type RecoverAccountArgs = {
  email: string
  recaptchaToken?: string
}

export type PasswordResetArgs = {
  email: string
  recaptchaToken?: string
}
